<template>
  <div>
    <h4 class="text-h4">
      {{ $t("pages.featureRequest.confirmation.title") }}
    </h4>
    <v-spacer class="mb-4"></v-spacer>
    <div>
      <v-row no-gutters>
        <v-col col="12" lg="8">
          <v-card elevation="1">
            <v-card-text>
              <div v-if="responseType === 'Accept'" class="text-center">
                <v-icon class="text-h2" color="green darken-2"
                  >mdi-check-circle-outline</v-icon
                >
              </div>
              <div v-else class="text-center">
                <v-icon class="text-h2" color="red darken-2"
                  >mdi-minus-circle-outline</v-icon
                >
              </div>
              <p class="text-h4 text--primary text-center">
                {{
                  responseType === "Accept"
                    ? $t("pages.featureRequest.confirmation.requestAccepted")
                    : $t("pages.featureRequest.confirmation.requestRejected")
                }}
              </p>
              <p v-if="responseType === 'Accept'" class="text-body-1">
                {{ $t("pages.featureRequest.confirmation.nowAccepted") }}
              </p>
              <p v-else class="text-body-1">
                {{ $t("pages.featureRequest.confirmation.nowRejected") }}
              </p>
              <p class="text-body-1">
                <b>{{
                  $t("pages.featureRequest.confirmation.primeUserMail")
                }}</b>
                {{ contactEmail }}
              </p>
              <p class="text-body-1">
                {{ $t("pages.featureRequest.confirmation.closeWindow") }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { appLayout } from "@/util/layout";

export default {
  layout: appLayout({ title: "pages.featureRequest.confirmation.title" }),
  props: {
    responseType: String,
    contactEmail: String,
  },
};
</script>
